import { runImpactCalculateVenueCo2ForDate } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-co2-for-date.action';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { deleteImpactCo2Answer } from '../delete-impact-co2-answer.action';

type Params = {
  projectId: number;
  dateId: number;
  answer: ImpactCo2Answer;
};

export const deleteImpactCo2AnswerVenueDate = createAppAsyncThunk(
  'impactCo2/deleteImpactCo2AnswerVenueDate',
  async (
    { projectId, dateId, answer }: Params,
    { dispatch },
  ): Promise<void> => {
    await dispatch(
      deleteImpactCo2Answer({
        projectId: dateId,
        answer,
        recalculateAfterSubmit: false,
      }),
    );
    dispatch(runImpactCalculateVenueCo2ForDate({ dateId, projectId }));
  },
);
